"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtOrderState2 = void 0;
var BtOrderState2;
(function (BtOrderState2) {
    /**
     * Order created. Ready to receive payment.
     */
    BtOrderState2["CREATED"] = "created";
    /**
     * Order expired.
     */
    BtOrderState2["EXPIRED"] = "expired";
    /**
     * Order sucessfully executed.
     */
    BtOrderState2["EXECUTED"] = "executed";
    /**
     * Order paid and ready to open channel.
     */
    BtOrderState2["PAID"] = "paid";
})(BtOrderState2 = exports.BtOrderState2 || (exports.BtOrderState2 = {}));
//# sourceMappingURL=BtOrderState2.js.map